module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUploadDiv),
      expression: "isShowUploadDiv"
    }]
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "mt-7": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "font-2x fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("uploadMaterial.selfie")))]), _vm._v(" "), _c('div', {
    staticClass: "font-lg mt-3"
  }, [_vm._v(_vm._s(_vm.userRequest.regEmail + ',') + _vm._s(_vm.$t("uploadMaterial.attachMessage")))]), _vm._v(" "), _c('v-form', {
    staticClass: "font-lg mt-3"
  }, [_c('Upload', {
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "action": "",
      "name": "upfile",
      "before-upload": _vm.beforeUpload,
      "show-upload-list": false
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.file !== null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.file.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearFile
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.clear")) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text mt-3",
    attrs: {
      "outline": "",
      "loading": _vm.uploadLoading,
      "disabled": _vm.file == null
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("uploadMaterial.upload")) + "\n                                    "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("cloud_upload")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowUploadDiv),
      expression: "!isShowUploadDiv"
    }]
  }, [_c('app-link-invalid')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb24856c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/request/UploadMaterial.vue
// module id = 475
// module chunks = 0